export default "__VITE_ASSET__9D5wDX6v__"